var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8932 18.3757C14.3398 18.3757 17.1336 17.8171 17.1336 17.1278C17.1336 16.4385 14.3398 15.8799 10.8932 15.8799C7.44659 15.8799 4.65283 16.4385 4.65283 17.1278C4.65283 17.8171 7.44659 18.3757 10.8932 18.3757Z",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1282 17.1279V20.8717C17.1282 21.5618 14.3352 22.1196 10.8878 22.1196C7.44046 22.1196 4.64746 21.5618 4.64746 20.8717V17.1279",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1282 20.8721V24.6158C17.1282 25.3059 14.3352 25.8638 10.8878 25.8638C7.44046 25.8638 4.64746 25.3059 4.64746 24.6158V20.8721",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1282 24.6162V28.36C17.1282 29.0501 14.3352 29.6079 10.8878 29.6079C7.44046 29.6079 4.64746 29.0501 4.64746 28.36V24.6162",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1282 28.3604V32.1041C17.1282 32.7942 14.3352 33.352 10.8878 33.352C7.44046 33.352 4.64746 32.7942 4.64746 32.1041V28.3604",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64746 13.3837V5.89538C4.64746 5.56402 4.77894 5.2471 5.01302 5.01302C5.2471 4.77894 5.56478 4.64746 5.89538 4.64746H32.104C32.4346 4.64746 32.7523 4.77894 32.9863 5.01302C33.2204 5.2471 33.3519 5.56478 33.3519 5.89538V20.8719C33.3519 21.2025 33.2204 21.5202 32.9863 21.7543C32.7523 21.9884 32.4346 22.1199 32.104 22.1199H20.248",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2563 13.3836C15.2563 12.6973 15.4456 12.0239 15.802 11.438C16.1592 10.852 16.6699 10.3747 17.2795 10.0593C17.889 9.74395 18.5737 9.60183 19.2585 9.64971C19.9433 9.69683 20.6022 9.93167 21.1623 10.3284C21.7224 10.7243 22.1632 11.2677 22.4361 11.897C22.7089 12.5271 22.8031 13.2194 22.7089 13.8996C22.6147 14.5798 22.335 15.2205 21.901 15.7525C21.4671 16.2845 20.8955 16.6865 20.248 16.9153",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2639 9.7041C9.95539 9.7041 9.70459 9.9549 9.70459 10.2635C9.70459 10.572 9.95539 10.8228 10.2639 10.8228C10.5725 10.8228 10.8233 10.572 10.8233 10.2635C10.8233 9.9549 10.5725 9.7041 10.2639 9.7041Z",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7361 15.9443C27.4276 15.9443 27.1768 16.1951 27.1768 16.5037C27.1768 16.8123 27.4276 17.0631 27.7361 17.0631C28.0447 17.0631 28.2955 16.8123 28.2955 16.5037C28.2955 16.1951 28.0447 15.9443 27.7361 15.9443Z",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14404 13.3839V7.76751C7.14404 7.60183 7.21016 7.44299 7.32644 7.32595C7.44348 7.20891 7.60232 7.14355 7.768 7.14355H30.2328C30.3985 7.14355 30.5574 7.20967 30.6744 7.32595C30.7914 7.44299 30.8568 7.60183 30.8568 7.76751V18.9996C30.8568 19.1652 30.7907 19.3241 30.6744 19.4411C30.5574 19.5582 30.3985 19.6235 30.2328 19.6235H20.2487",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaims);
export default __webpack_public_path__ + "static/media/claims.1f4baed43e521b49b11a3d84c9ebfb79.svg";
export { ForwardRef as ReactComponent };